import { FilterableInterface } from './filterable.interface';

export class ManufacturingOrderFile implements FilterableInterface {
  constructor(
    public hash?: string,
    public fileName?: string,
    public filePath?: string,
    public fileCategoryName?: string,
    public lastUpdate?: number,
    public assembly3D?: boolean,
    public assemblyDrawing?: boolean
  ) { }

  get filterableData() {
    return `${ this.fileName }`.toLowerCase();
  }

  get name() {
    return this.fileName;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/manufacturing-order-file.ts